import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const NorskTippingMeta = ({ article }) => {
    const { customProperties: { vg_tippetips: addTippetips } = {} } = article;

    if (!addTippetips) {
        return null;
    }

    return (
        <Helmet>
            <meta name="article:tag:type" content="Tippetips" />
            <script src="//tags.tiqcdn.com/utag/norsktipping/affiliate/prod/utag.js" defer />
        </Helmet>
    );
};

NorskTippingMeta.propTypes = {
    article: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default NorskTippingMeta;



/** WEBPACK FOOTER **
 ** ./src/local-components/NorskTippingMeta.js
 **/